import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from './messages/LicenseContactPerson';

import Button from '../../components/Button';
import ContactPersonManager from '../paid/contactperson.container';
import LoadingIndicator from '../../components/LoadingIndicator';
import './styles/LicenseContactPerson.scss';

const propTypes = {
  buttons: PropTypes.object,
  companyId: PropTypes.number.isRequired,
  initialContactPerson: PropTypes.object,
  onCancel: PropTypes.func,
  onSelect: PropTypes.func,
}

const defaultProps = {
  buttons: {},
  initialContactPerson: null,
  onCancel: () => {},
  onSelect: () => {},
}

const LicenseContactPersonManager = ({
  buttons, companyId, initialContactPerson, onCancel, onSelect
}) =>
  <div styleName='LicenseContactPersonManager'>
    <ContactPersonManager
      companyId={companyId}
      externalControls
      initialContactPerson={initialContactPerson}
    >
      {({
        currentContactPerson,
        cancelAdd,
        cancelUpdate,
        isAdd,
        isInfo,
        isUpdate,
        isValid,
        onAdd,
        onUpdate,
        update,
        working,
      }) =>
        <div styleName='controls'>
          {isAdd && (
            <React.Fragment>
              {buttons.confirmAdd
                ? buttons.confirmAdd(onAdd)
                : <Button
                    disabled={!isValid || working}
                    id='license-contact-person-add-form-submit-button'
                    onClick={onAdd}
                  >
                    {working && <LoadingIndicator />}
                    <FormattedMessage { ...messages.confirmAddButtonLabel } />
                  </Button>
              }
              <div styleName='padder' />
              {buttons.cancelAdd
                ? buttons.cancelAdd(cancelAdd)
                : <Button
                    disabled={working}
                    id='license-contact-person-add-form-cancel-button'
                    onClick={cancelAdd}
                    color='orange'
                  >
                    <FormattedMessage { ...messages.cancelAddButtonLabel } />
                  </Button>
              }
            </React.Fragment>
          )}
          {isUpdate && (
            <React.Fragment>
              {buttons.confirmUpdate
                ? buttons.confirmUpdate(onUpdate)
                : <Button
                    disabled={!isValid || working}
                    id='license-contact-person-update-form-submit-button'
                    onClick={onUpdate}
                  >
                    {working && <LoadingIndicator />}
                    <FormattedMessage
                      { ...messages.confirmUpdateButtonLabel }
                    />
                  </Button>
              }
              <div styleName='padder' />
              {buttons.cancelUpdate
                ? buttons.cancelUpdate(cancelUpdate)
                : <Button
                    disabled={working}
                    onClick={cancelUpdate}
                    id='license-contact-person-update-form-cancel-button'
                    color='orange'
                  >
                    <FormattedMessage { ...messages.cancelUpdateButtonLabel } />
                  </Button>
              }
            </React.Fragment>
          )}
          {(!isUpdate && !isAdd) && (
            <React.Fragment>
              {buttons.continue
                ? buttons.continue({
                  working,
                  onClick: () => onSelect({
                    contactPerson: currentContactPerson,
                  }),
                })
                : <Button
                    disabled={!currentContactPerson || working}
                    id='license-contact-person-continue-button'
                    onClick={() =>
                      onSelect({ contactPerson: currentContactPerson })
                    }
                  >
                    <FormattedMessage { ...messages.continueButtonLabel } />
                  </Button>
              }
              {isInfo && (
                <React.Fragment>
                  <div styleName='padder' />
                  {buttons.update
                    ? buttons.update({ working, onClick: update })
                    : <Button
                        disabled={working}
                        id='license-contact-person-udpate-button'
                        onClick={update}
                      >
                        <FormattedMessage { ...messages.updateButtonLabel } />
                      </Button>
                  }
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          {buttons.back
            ? buttons.back({
              working,
              onClick: () => onCancel({ contactPerson: currentContactPerson }),
            })
            : <Button
                disabled={working}
                id='license-contact-person-back-button'
                kind='tertiary'
                onClick={
                  () => onCancel({ contactPerson: currentContactPerson })
                }
                styleName='back-button'
                color='grey'
              >
                <FormattedMessage { ...messages.backButtonLabel } />
              </Button>
          }
        </div>
      }
    </ContactPersonManager>
  </div>;

LicenseContactPersonManager.propTypes = propTypes;
LicenseContactPersonManager.defaultProps = defaultProps;

const LicenseContactPerson = props =>
  <div styleName='LicenseContactPerson'>
    <strong><FormattedMessage {...messages.title} /></strong>
    <p><FormattedMessage {...messages.info} /></p>
    <LicenseContactPersonManager { ...props } />
  </div>;

export default LicenseContactPerson;
export { LicenseContactPersonManager };
